/* src/app/shared/components/list-view/list-view.component.scss */
/*# sourceMappingURL=list-view.component-YQLGYWLP.css.map */
